<template>
  <div>
    <v-toolbar
      color="theme_primary"
      dark
      extension-height="36"
      height="36"
      flat
      app
    >
      <v-toolbar-side-icon @click="drawerToggle()">
        <v-icon>{{ drawerIcon() }}</v-icon>
      </v-toolbar-side-icon>
      <v-layout align-center>
        <v-icon size="12" left>person</v-icon>
        <v-breadcrumbs
          :items="[
            {
              exact: true,
              text: 'Profile settings',
              disabled: false,
              to: '/profile',
            },
          ]"
          dark
        >
          <template v-slot:divider>
            <v-icon>chevron_right</v-icon>
          </template>
        </v-breadcrumbs>
      </v-layout>
    </v-toolbar>

    <v-layout pa-2 justify-center>
      <v-flex>
        <v-card height="100%" flat>
          <v-layout column justify-center>
            <v-layout align-center column class="ma-3" text-xs-center>
              <v-tooltip right>
                <div @click="showUploadDialog = true" slot="activator">
                  <userAvatar
                    :size="300"
                    :last_name="user ? user.last_name : 'User'"
                    :first_name="user ? user.first_name : 'Deleted'"
                    :url="user ? user.avatar_url : ''"
                  />
                </div>

                <span>Upload new profile picture</span>
              </v-tooltip>
            </v-layout>

            <v-layout justify-center class="ma-2">
              <v-flex xs12 md8 lg4>
                <v-dialog v-model="showUploadDialog" width="45%">
                  <v-card>
                    <v-toolbar
                      tile
                      card
                      flat
                      height="36"
                      color="theme_primary"
                      class="white--text"
                    >
                      <v-toolbar-side-icon>
                        <v-icon small color="white">mdi-cloud-upload</v-icon>
                      </v-toolbar-side-icon>
                      <v-spacer></v-spacer>
                      <v-toolbar-title class="white-text subheading"
                        >Upload new profile picture</v-toolbar-title
                      >
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                      <uploader
                        name="exp-12"
                        v-on:s3url="updateAvatarUrl($event)"
                      />
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn @click="showUploadDialog = false" flat color="red"
                        >Close</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-flex>
            </v-layout>

            <v-layout align-center column class="ma-2" text-xs-center>
              <h1 class="theme_primary--text">
                {{ currentUser.first_name }} {{ currentUser.last_name }}
              </h1>
              <h5>{{ currentUser.email }}</h5>
            </v-layout>

            <v-layout justify-center class="ma-3">
              <v-flex xs12 md8 lg6 xl4 >
                <v-text-field
                  label="First name"
                  :value="currentUser.first_name"
                  @input="updateUserField('first_name', $event)"
                  @change="updateUser"
                  required
                />
                <v-text-field
                  label="Last name"
                  :value="currentUser.last_name"
                  @input="updateUserField('last_name', $event)"
                  @change="updateUser"
                  required
                />
                <v-text-field
                  label="Email"
                  :value="currentUser.email"
                  @input="updateUserField('email', $event)"
                  @change="updateUser"
                  required
                />
                <v-layout align-center column class="ma-2">
                  <v-btn v-if="!currentUser.otp_module_enable" color="primary" @click="toggleOtpModule(currentUser.otp_module_enable)" slot="activator">
                    Enable Google Authenticator
                  </v-btn>
                  <v-btn v-else color="primary" @click="toggleOtpModule(currentUser.otp_module_enable)" slot="activator">
                    Disable Google Authenticator
                  </v-btn>
                </v-layout>

                <v-layout v-if="currentUser.otp_module_enable" align-center column class="ma-2">
                    <qrcode-vue
                      v-bind:value="currentUser.otp_provisioning_uri"
                      :size="350"
                      level="H"
                      class="mt-3"
                    />
                    <ol>
                      <li>Install Google Authenticator: <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US" target="_blank">Android</a> or <a href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank">iOS</a></li>
                      <li>In the App, select "Set up account" or the + sign</li>
                      <li>Choose "Scan barcode"</li>
                    </ol>
                      <v-card-text v-if="currentUser.otp_counter == 0">
                        <v-alert
                          :value="true"
                          color="primary"
                          icon="priority_high"
                          outline
                        > <strong>Important!</strong><p>Write these backups codes down in a safe place. They can be used once to login to your account if your 2FA device is unavailable. They will never be displayed again for security.</p>
                        <v-card class="d-inline-flex pa-2">
                          <div pa-2 v-for="backup_code in currentUser.otp_backup_codes" :key="backup_code" id="backup-code">
                            <div>
                              <strong class="pa-2">{{ backup_code }}</strong>
                            </div>
                          </div>
                          <v-icon small @click="copyToClipBoard()">content_copy</v-icon>
                        </v-card>
                        </v-alert>
                      </v-card-text>
                  </v-layout>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import icons from "../mixins/icons.js";
import uploader from "../components/shared/uploader";
import UPDATE_USER from "../graphql/users/update.gql";
import userAvatar from "../components/shared/userAvatar";
import QrcodeVue from "qrcode.vue";
export default {
  name: "profile",
  mixins: [icons],
  components: {
    uploader,
    userAvatar,
    QrcodeVue,
  },
  data() {
    return {
      showUploadDialog: false,
      user: {},
    };
  },
  computed: {
    ...mapGetters("currentUserStore", ["currentUser"]),
  },
  methods: {
    updateUser() {
      this.sendMutation("updated", "user", UPDATE_USER, this.user).then(
        (data) => {
          this.$store.commit(
            "currentUserStore/rehydrateUser",
            data.update_user
          );
          this.resetUser();
        }
      );
    },
    toggleOtpModule(otp_enabled) {
      this.updateUserField("otp_module", + !otp_enabled);
      this.updateUserField("otp_counter", 0);
      this.updateUser();
    },
    updateUserField(nameField, newValue) {
      this.user[nameField] = newValue;
    },
    resetUser() {
      const fields = ["id", "first_name", "last_name", "email", "avatar_url", "otp_module", "otp_counter"];
      fields.forEach((f) => {
        this.user[f] = this.currentUser[f];
      });
    },
    updateAvatarUrl(event) {
      this.updateUserField("avatar_url", event);
      this.updateUser();
      this.showUploadDialog = false;
    },
    copyToClipBoard() {
      const backUpCodes = document.querySelectorAll("#backup-code");
      const backUpCodesArray = [...backUpCodes].map((backupcode) => backupcode.textContent )
      navigator.clipboard.writeText(backUpCodesArray).then(function() {
        /* clipboard successfully set */
      }, function() {
        /* clipboard write failed */
      });
    },
  },
  created() {
    this.resetUser();
  },
};
</script>
<style lang="stylus" scoped>
.avatar {
  width: 230px !important;
  height: 230px !important;
  margin: 20px;
  cursor: pointer;

  &:hover {
    img {
      filter: grayscale(100%);
    }
  }
}
</style>
